import { render, staticRenderFns } from "./restaurant_zone.vue?vue&type=template&id=02424846&scoped=true&"
import script from "./restaurant_zone.vue?vue&type=script&lang=js&"
export * from "./restaurant_zone.vue?vue&type=script&lang=js&"
import style0 from "./restaurant_zone.vue?vue&type=style&index=0&id=02424846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02424846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02424846')) {
      api.createRecord('02424846', component.options)
    } else {
      api.reload('02424846', component.options)
    }
    module.hot.accept("./restaurant_zone.vue?vue&type=template&id=02424846&scoped=true&", function () {
      api.rerender('02424846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/restaurant_zone.vue"
export default component.exports